import { PropertyMappingEntityEnum } from './property-mapping-entity.enum';

export const ViewColumnMappingEntityEnum = {
  ...PropertyMappingEntityEnum,
  check: 'check',
} as const;
export type ViewColumnMappingEntityEnum =
  (typeof ViewColumnMappingEntityEnum)[keyof typeof ViewColumnMappingEntityEnum];
